// =============================================================================
// GiftCardModal — a scanned physical gift card (Scan screen): status, balance
// and, for staff with booking_gift_card_sell, Activeren / Waarde toevoegen.
// =============================================================================
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { formatError } from '../lib/errors';
import { fetchGiftCardDetail, formatGiftCode, type GiftCardDetail } from '../lib/giftcard';
import { GiftCardView } from './GiftCardView';
import { GiftCardLoadAction } from './GiftCardLoadAction';

export function GiftCardModal({ code, onClose }: { code: string; onClose: () => void }) {
  const [detail, setDetail] = useState<GiftCardDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const d = await fetchGiftCardDetail(code);
      if (!d) setError('Deze cadeaubon bestaat niet.');
      setDetail(d);
    } catch (e) {
      setError(formatError(e));
    } finally {
      setLoading(false);
    }
  }, [code]);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="dep-modal-backdrop" onClick={() => { /* ✕ only */ }}>
      <div className="dep-modal giftcard-modal" onClick={(e) => e.stopPropagation()}>
        <header className="dep-modal-head">
          <div>
            <h2>Cadeaubon</h2>
            <div className="dep-modal-sub muted">{formatGiftCode(code)}</div>
          </div>
          <button className="btn-link dep-modal-close" onClick={onClose} aria-label="Sluiten">✕</button>
        </header>
        <div className="dep-modal-body">
          {loading ? <div className="muted">Laden…</div> : null}
          {error ? <div className="error-card">{error}</div> : null}
          {detail ? (
            <>
              <GiftCardView
                detail={detail}
                compact
                onChanged={() => void load()}
                loadAction={<GiftCardLoadAction card={detail.card} onSettled={() => void load()} />}
              />
              <Link to={`/cadeaubon/${detail.card.code}`} className="btn-link">Alle details →</Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
